module.exports = __webpack_public_path__ + "5bc21c8f08c6cd05fa73cf0c8696cbae.woff";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/Lato-LightItalic.woff
// module id = 705
// module chunks = 0